"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseIntakeUrl = exports.getApiUrl = exports.getIntakeUrl = exports.getDatadogSite = exports.getDatadogSiteFromEnv = void 0;
const constants_1 = require("../constants");
/**
 * Read the Datadog site from `DATADOG_SITE` / `DD_SITE` env vars.
 * Returns `undefined` when neither is set.
 */
const getDatadogSiteFromEnv = () => process.env.DATADOG_SITE || process.env.DD_SITE;
exports.getDatadogSiteFromEnv = getDatadogSiteFromEnv;
/**
 * Single source of truth for Datadog site resolution. If `site` is passed, returns it.
 * Otherwise reads from `DATADOG_SITE` / `DD_SITE` env vars with US1 fallback.
 */
const getDatadogSite = (site) => site || (0, exports.getDatadogSiteFromEnv)() || constants_1.DATADOG_SITE_US1;
exports.getDatadogSite = getDatadogSite;
/**
 * Build `https://{subdomain}.{site}` with optional env var override.
 */
const getIntakeUrl = (subdomain, options) => {
    if (options === null || options === void 0 ? void 0 : options.overrideEnvVar) {
        const override = process.env[options.overrideEnvVar];
        if (override) {
            return override;
        }
    }
    return `https://${subdomain}.${(0, exports.getDatadogSite)(options === null || options === void 0 ? void 0 : options.site)}`;
};
exports.getIntakeUrl = getIntakeUrl;
/**
 * Build the full API URL (`https://api.{site}`) for a given site.
 */
const getApiUrl = (site) => `https://api.${(0, exports.getDatadogSite)(site)}`;
exports.getApiUrl = getApiUrl;
/**
 * @deprecated Use {@link getIntakeUrl} instead.
 *
 * Get the base intake URL for a service. If the `DD_SITE` or `DATADOG_SITE` environment
 * variables are not defined, use the default site (US1).
 */
const getBaseIntakeUrl = (intake) => (0, exports.getIntakeUrl)(intake);
exports.getBaseIntakeUrl = getBaseIntakeUrl;
//# sourceMappingURL=api.js.map